import React from 'react';
import { Button } from 'react-bootstrap';
import { Popup } from 'react-leaflet';
import COLORS from "../Helpers/utils";
import LabelTag from "./LabelTagComponent";
import {useNavigate} from "react-router-dom";
import noReception from "../Images/no_reception.png"
import {BuildingSummary} from "../types/protocols";
import {colorForBuildingType, nameForBuildingType} from "../types/BuildingTypeEnums";
import {placeholderForBuildingType} from "../Helpers/PlaceholderUtils";

interface MapPopupProps {
    building: BuildingSummary;
}

const MapPopup: React.FC<MapPopupProps> = ({ building }) => {
    const navigate = useNavigate(); // Add this hook

    const handleClick = () => {
        navigate(`/building/${building.key}`);
    };

    return (
        <Popup offset={[1, 52]}>
            <div
                style={{
                    position: 'relative',
                    left: '-21px',
                    top: '-14px',
                    width: '102%',
                    height: '100px',
                    backgroundColor: COLORS.lightLightGrey,
                }}
            >
                <div style={{position: "absolute", left: '8px', top: '8px'}}>
                    <LabelTag text={nameForBuildingType(building.buildingType).toUpperCase()} backgroundColor={colorForBuildingType(building.buildingType)} />
                </div>

                <img
                    src={building.coverPhoto?.mediumSizeUrl || placeholderForBuildingType(building.buildingType)}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'stretch', maxWidth: '200px' }}>
                <div style={{
                    width: '5px',
                    backgroundColor: COLORS.primaryDark,
                    marginRight: '10px',
                    marginLeft: '-15px',
                    borderRadius: '3px'
                }} />
                <div style={{
                    width: '100%'
                }}>
                    <div>
                    {
                        building.groupTags &&
                        <>{
                            Object.values(building.groupTags).map((tag)=> {
                                return <LabelTag text={tag.tag} backgroundColor={COLORS.redOrange} marginBottom={3} />
                            })
                        }
                        </>
                    }

                    {
                        building.buildingInfo?.hasPoorReception &&
                        <img src={noReception} style={{width: '20px', height: '20px', marginLeft: '5px', marginTop: '-4px'}}/>
                    }
                    </div>

                    <strong style={{ fontSize: '11pt', fontFamily: 'Source Sans Pro', }}>
                        {building.name}
                    </strong>
                    <br />
                    <span style={{ marginTop: '5px', fontFamily: 'Source Sans Pro', }}>
                        {building.locationCategories?.category2?.name || ''}
                    </span>
                    <br />
                    <span style={{ marginTop: '5px', fontFamily: 'Source Sans Pro', }}>
                        {building.locationCategories?.category1?.name || ''}
                    </span>
                    <br />
                    <div style={{ marginTop: '45px' }}>

                    </div>
                </div>
            </div>

            <Button
                className="small-button-style"
                style={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: '10px'
                }}
                variant="secondary"
                onClick={handleClick}
            >
                ÖPPNA
            </Button>
        </Popup>
);
};

export default MapPopup;